import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { apiClient } from '../../../helpers/apiHelper';
import logo from '../../assets/logo-dark-blue.png';

export const SUPPORT_EMAIL = 'support@deepecho.io';
export const TRIAL_DAYS = 60;
export const FONT =
  "'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif";

let selfSignup: Promise<boolean> | null = null;

/** Whether this tenant runs the training portal; asked once per page load. */
export const useSelfSignup = () => {
  const [on, setOn] = useState<boolean | null>(null);
  useEffect(() => {
    if (!selfSignup) {
      selfSignup = apiClient
        .get('/signup/available')
        .then(() => true)
        .catch(() => false);
    }
    selfSignup.then(setOn);
  }, []);
  return on;
};

export const BrandBlock = ({ row }: { row?: boolean }) => {
  const { t } = useTranslation('Signup');
  return (
  <Link
    to="/"
    aria-label="DeepEcho Training home"
    className={`flex no-underline ${row ? 'items-center gap-3' : 'flex-col gap-[9px]'}`}
  >
    <img
      src={logo}
      alt="DeepEcho"
      className={`block w-auto ${row ? 'h-[18px]' : 'h-5 self-start'}`}
    />
    <span
      className={`font-semibold tracking-[.06em] text-[#656F7D] ${row ? 'hidden text-[11px] sm:inline' : 'text-[12px]'}`}
    >
      {t('sidebar.trainingPortal')}
    </span>
  </Link>
);
};

export const HelpLine = () => {
  const { t } = useTranslation('Signup');
  return (
    <span className="text-[12px] font-medium text-[#656F7D]">
      {t('sidebar.needHelp')} <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
    </span>
  );
};
